module.exports = {
    appUrl: process.env.appUrl,
    apiUrl: process.env.apiUrl,
    mediaUrl: process.env.mediaUrl,
    unsubscribedQueryKey: 'unsubscribed',
    tinymce: process.env.tinymce,
    cdn: process.env.cdn,
    aiChatbotKey: process.env.aiChatbotKey
};
